import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormOverdueReplyConfig } from '../models/form/form-overdue-reply-config.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class FormOverdueReplyConfigService extends RequestService<FormOverdueReplyConfig> {
  static PATH = '/om/form/overdueReplyConfig';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(
      httpClient,
      FormOverdueReplyConfigService.PATH,
      globalService.debugUrl
    );
  }
}
